import { Link, useNavigate } from 'react-router-dom';

// material-ui
import { Alert, Button, CircularProgress, Grid, Stack, Typography } from '@mui/material';

// project import
import { UserAuthContext } from 'context/UserAuthContext';
import React, { useEffect } from 'react';
import AuthLogin from './auth-forms/AuthLogin';
import AuthWrapper from './AuthWrapper';
import { useAppBridge } from '@shopify/app-bridge-react';
import { getSessionToken } from '@shopify/app-bridge/utilities';
// ================================|| LOGIN ||================================ //

const ShopifyLogin = () => {
    const { isLoggedIn } = React.useContext(UserAuthContext);
    const [submitting, setSubmitting] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const navigate = useNavigate();
    const app = useAppBridge();

    const refreshSession = async () => {
        const shopifyToken = await getSessionToken(app);
        isLoggedIn(shopifyToken).then((yesNo) => {
            if(yesNo){
                const shop = localStorage.getItem('shopify_shop');
                if (shop) {
                    const url = new URL(window.location.href);
                    setSubmitting(false)
                    if (url.searchParams.has('returnUrl')) {
                        const retUrl = url.searchParams.get('returnUrl');
                        navigate(retUrl)
                    } else {
                        navigate('/')
                    }
                }else{
                    setSubmitting(false);
                }
            }else{
                setSubmitting(false);
            }
        })
    }

    useEffect(() => {
        setSubmitting(true);
        refreshSession();
    }, []);

    return <AuthWrapper insideCard={false}>
        {submitting && errors.length === 0 ? <CircularProgress color="secondary" /> : (
            <>
                <Typography variant="body1">You session has ended</Typography>
                {errors.length > 0 && (
                    <>
                        {errors}
                    </>
                )}
                <Button
                    disableElevation
                    disabled={submitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => refreshSession()}
                >
                    Refresh Login
                </Button>
            </>
        )}
    </AuthWrapper>

}
const RegularLogin = () => {
    return <AuthWrapper insideCard={true}>
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
                    <Typography variant="h3">Login</Typography>
                    <Typography component={Link} to="/register" variant="body1" sx={{ textDecoration: 'none' }} color="primary">
                        Don&apos;t have an account?
                    </Typography>
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <AuthLogin />
            </Grid>
        </Grid>
    </AuthWrapper>

}
const Login = () => {
    const { isShopifyApp } = React.useContext(UserAuthContext);

    if (isShopifyApp()) {
        return <ShopifyLogin />
    }
    return <RegularLogin />
}

export default Login;
